import { Box, SxProps } from '@mui/material';
import { FC, useEffect, useRef, useState } from 'react';
import { Chip } from '../../../../../../../atomic/dataDisplay/chip';
import { TableRoofMoreMenu } from './moreMenu';

export type Chip = {
  label: string;
  onDelete?: () => void;
};

type Props = {
  chips: Array<Chip>;
  justify?: string;
  sx?: SxProps;
};
export type TableRoofChipListProps = Props;

const HEURISTIC_CHIP_LENGTH = 158;
const MORE_CHIP_SIZE = 50;

export const TableRoofChipList: FC<Props> = ({ chips, justify, sx }) => {
  const boxRef = useRef<HTMLElement>();
  const [visibleChips, setVisibleChips] = useState<Array<Chip>>([]);
  const [moreChips, setMoreChips] = useState<Array<Chip>>([]);

  const createChips = () => {
    if (boxRef.current) {
      const availableSpace = boxRef.current.clientWidth;
      const neededSpace = chips.length * HEURISTIC_CHIP_LENGTH;
      if (availableSpace < neededSpace) {
        const numberOfVisibleChips = Math.floor(
          (availableSpace - MORE_CHIP_SIZE) / HEURISTIC_CHIP_LENGTH
        );

        setVisibleChips([...chips.slice(0, numberOfVisibleChips)]);
        setMoreChips([...chips.slice(numberOfVisibleChips)]);

        return;
      }

      setVisibleChips([...chips]);
      setMoreChips([]);
    }
  };

  useEffect(() => createChips(), [chips]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: justify || 'flex-start',
        minWidth: '100px',
        width: '100%',
        ...sx
      }}
      ref={boxRef}
    >
      {visibleChips.map((chip) => (
        <Chip
          key={chip.label}
          size="small"
          color="heaven"
          filled={true}
          label={chip.label}
          onDelete={chip.onDelete}
          sx={{ marginRight: '12px' }}
        />
      ))}
      {moreChips.length > 0 && <TableRoofMoreMenu remainingChips={moreChips} />}
    </Box>
  );
};
